var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    height: "800px",
    width: "800px",
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.5328 43.6199)",
    cx: 48.4,
    cy: 32.1,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 0.6129 65.6996)",
    cx: 79.6,
    cy: 32.1,
    rx: 9.8,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,60.2l-21.5-21.5c-2.9-2.8-7.6-2.8-10.4,0c-0.6,0.6-2.8,2.8-3.4,3.4c-0.7,0.7-1.2,1.6-1.6,2.4l-6.1,16.7l-15.2,7 l-15.2-7l-6.1-16.7c-0.4-0.9-0.9-1.7-1.6-2.4c-0.6-0.6-2.8-2.8-3.4-3.4c-2.8-2.8-7.4-2.8-10.4,0L5.8,60.2c-1.5,1.5-2.2,3.3-2.2,5.3 v50.7c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1V76c1.3-0.2,2.7-1,3.8-2l18.2-18.2l3.7,10c0.4,1.1,1.2,2,2.2,2.4l17.7,8.3 c0.9,0.4,1.8,0.5,2.6,0.3c0.9,0.2,1.8,0.1,2.6-0.3l17.7-8.3c1-0.5,1.8-1.3,2.2-2.4l3.7-10l18.2,18.2c1.1,1,2.4,1.7,3.8,2v40.1 c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1V65.4C124.4,63.5,123.7,61.6,122.2,60.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPart);
export default __webpack_public_path__ + "static/media/part.64c038591410b1f0d0b2f6acd1d5f16f.svg";
export { ForwardRef as ReactComponent };